export enum SimpleStatusEnum {
    OK = 'ok',
    KO = 'ko',
}
